export const actionTypes = {
    FETCH_LIKED_MAPS_SUCCESS: 'SOCIAL/FETCH_LIKED_MAPS_SUCCESS',
};
